import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { IMiaRouteMatch } from '../components/hooks';

interface IHeaderTitleProps {
  matchingRoute: IMiaRouteMatch | undefined;
}

const useStyles = makeStyles(
  createStyles({
    flexContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    flexGrow: {
      flexGrow: 1
    }
  })
);

let HeaderTitle: React.FunctionComponent<IHeaderTitleProps> = ({ matchingRoute }) => {
  // const route = location.pathname ? routes[location.pathname] : undefined;
  const classes = useStyles();
  const loc = useLocation();

  const title = React.useMemo(() => {
    let tempTitle = matchingRoute?.route.name ?? loc.pathname;

    if (matchingRoute?.route.path.includes(':')) {
      tempTitle = `${tempTitle.trim()} ${Object.entries(matchingRoute.params).filter(([key]) => key !== '*')[0][1]}`;
    }

    return tempTitle;
  }, [matchingRoute, loc.pathname]);

  return (
    <Typography variant="h6" color="inherit" noWrap className={classes.flexGrow}>
      {title}
    </Typography>
  );
};

HeaderTitle = React.memo<IHeaderTitleProps>(HeaderTitle);
export { HeaderTitle };
